<template>
  <div class="main-con el-main">
    <nav-breadcrumb :menu="[{label: '客户还款余额表'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :tableData="listData"
        :columns="listColumns"
        :pageSize.sync="pageSize"
        :page.sync="page"
        :filters="filters"
        :actions="actions"
      >
          <div slot="TableTop">
              <el-col :span="6"><div class="Htitle-text color-deep-blue">笔数合计：{{listData.count}}</div></el-col>
              <el-col :span="6"><div class="Htitle-text color-deep-blue">本期余额：{{(balanceAmounts/10000).toFixed(2)||''}}</div></el-col></div>
      </data-table>

    </el-row>
    <el-dialog
      title="处理"
      :visible.sync="dialogVisible"
      width="30%">
      <el-radio-group v-model="excessAmountOption">
        <el-radio label="Profit">转营业外收入</el-radio>
        <el-radio label="Refund">返还客户</el-radio>
          <el-radio label="Refund-ToDealer">返还渠道商</el-radio>

      </el-radio-group>
      <div class="tr xzmt">
        <el-button type="primary" @click="onSubmit('true')">确认</el-button>
        <el-button type="" @click="onSubmit('false')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  export default {
    name: "RepaymentExcessAmountList",
    data() {
      return {
        dialogVisible:false,
        excessAmountOption:'',
          balanceAmounts:0,
        repayments:'',
        transactionStatus: this.$route.query['fi.transactionStatus'],
        page: 1,
        pageSize: 20,
        listData: {},
        listColumns: [
          {
            name: '序号',
            type: 'index'
          },
          {
            name: '贷款合同号',
            field: 'fi__transactionNo'
          },

          {
            name: '客户姓名',
            field: 'fi__customerName'
          },

          {
            name: '贷款状态',
            field: 'fi__transactionStatus',
            formatter: function (r,c,v) {
              return v=='Pending Approval'?'待审核':Status2CN('Financing_'+v)
            }
          },


          {
            name: '交易金额',
            field: 'de__creditAmount',
            formatter: function (r,c,v) {
              if(v)
              return formatMoney(v)
            }
          },
          {
            name: '网银交易日期',
            field: 'de__txDate',
            formatter: function (r,c,v) {
              if(v)
                return moment(v).format('YYYY-MM-DD')
            }
          },


          {
            name: '本期余额',
            field: 're__excessAmount',
            formatter: function (r,c,v) {
              return formatMoney(v)
            }
          },
          {
            name: '处理方式',
            field: 're__excessAmountOption',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作',
            width: '180',
            opts: [
              {
                label: '处理',
                class: 'el-icon-finished',
                clickHandler: (index, row)=> {
                  this.excessAmountOption = 'Profit'
                  this.dialogVisible = true
                  this.repayments = row.re__repaymentId
                }
              },
            ]
          }
        ],
        filters: {
          labelWidth: '150px',
          form: {
            de__txDate:[],
            fi__customerName:'',
            re__excessAmountOption:'',
          },
            rules: {
                de__txDate:{
                    required:true,
                    message: '不能为空'
                }
            },
          columns: [
            {
              label: '网银交易日期',
              component: 'date-range-picker',
              field: 'de__txDate',
              op: ['gteq', 'lteq'],
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'fi__customerName',
            },
            {
              label: '处理方式',
              component: 'el-select',
              field: 're__excessAmountOption',
              options:[
                {
                  label:'转入下期',
                  value:'None'
                },
                {
                  label:'记入营业外收入',
                  value:'Profit'
                },
                {
                  label:'返还客户',
                  value:'Refund'
                },
                {
                  label:'返还渠道商',
                  value:'Refund-ToDealer'
                }
              ]
            },


          ],
          onSubmit:()=>{
            this.page = 1
            this.getRepaymentExcessAmountList()
              this.getRepaymentExcessAmountList2()
          },
            onReset: ()=> {
                this.filters.form = {
                    de__txDate:[],
                    fi__customerName:'',
                    re__excessAmountOption:'',
                }
                this.getRepaymentExcessAmountList()
                this.getRepaymentExcessAmountList2()
            }
        },

        actions: [
          {
            label: '导出',
            clickHandler:()=>{
                if(this.filters.form.de__txDate.length==0){
                    this.$message.error('请填写网银交易日期')
                    return false
                }
              let routeData = this.$router.resolve({
                path: '/ix/fang/repayment/RepaymentExcessAmount.List?format=xls',
                query: Object.assign(
                  {
                      pageSize:0,
                      frDate:this.filters.form.de__txDate[0]||'1900-12-31 00:00:00',
                      'frDate.dateformat':'yyyy-MM-dd',
                      toDate:this.filters.form.de__txDate[1]||'2099-12-31 00:00:00',
                      'toDate.dateformat':'yyyy-MM-dd',
                      'xlist.sort.dataField': 'de.txDate',
                      'xlist.sort.order': 'desc'

                  }, {}, xmlBuildQuery(this.filters))
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ]
      }
    },
    computed : {
      filterParams: {
        get: function() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'de.txDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getRepaymentExcessAmountList()
          this.getRepaymentExcessAmountList2()
      }
    },
    mounted() {
     /* this.getRepaymentExcessAmountList()
        this.getRepaymentExcessAmountList2()*/
    },
    methods: {
      getRepaymentExcessAmountList: function () {
        xhr.getRepaymentExcessAmountList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.listData = res.data
            }catch(e){

            }
          })

      },
        getRepaymentExcessAmountList2: function () {
            xhr.getRepaymentExcessAmountList(
                Object.assign({pageSize:0}, {}, xmlBuildQuery(this.filters)),
                res=> {
                    try {
                        let listData = res.data
                        this.balanceAmounts = 0
                        listData.data.forEach(item=>{
                            if(item.re__excessAmount){
                                this.balanceAmounts = this.balanceAmounts +parseFloat(item.re__excessAmount)*10000
                            }
                        })
                    }catch(e){

                    }
                })

        },
      onSubmit:function (val) {
        if(val=='true'){

           xhr.UpdateExcessAmountOption(
             {
               'repayments':this.repayments,
               'option':this.excessAmountOption,
             },
             res=> {
               try{
                 if(res.data.status == 'success') {
                   this.dialogVisible = false
                   this.getRepaymentExcessAmountList()
                     this.getRepaymentExcessAmountList2()
                 }else{

                   this.$message.error(res.data.msgs[0].text)
                 }

               }catch (e) {

                 this.$message.error(error.msgs[0].text)

               }
             }
           )
        }else{
          this.dialogVisible = false
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/RepaymentExcessAmountList.vue